export default __webpack_public_path__ + "static/media/logo.dfcf3dff.png";